module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Left-circle-44364d0b3c8e3c7a384df0197b253120.svg";